import { useEffect , useState} from 'react';
import './Cards.scss';
import { useSelector } from 'react-redux';
import { clickHandler, isGemidsNull } from '../../shared/utility';

function Cards() {
    const gemId2 = useSelector((state) => state.AppState.gemId2);
    const gemId1 = useSelector((state) => state.AppState.gemId1);
    const savedChannelCode = useSelector((state) => state.AppState.channelCode);
    const contentCardList = useSelector((state) => state.AppState.cardList);
    const [cardList,setCardList] = useState([]);
    const isVerticalCard = (cardType) => {
        if (window.global?.config?.verticalCardList) {
          return window.global?.config?.verticalCardList.indexOf(cardType) !== -1;
        }
    }

   useEffect(() => {
      if (window.global?.config) {
         const cardSortedList = contentCardList.filter( card => card.productType !== "" && card.cardType!== "" && window.global?.config?.[savedChannelCode].indexOf(card.productType) !== -1 )
         const unique = cardSortedList.filter(
            (obj, index) =>
              cardSortedList.findIndex((item) => item.productType === obj.productType) === index
          );
          const allCards = window.global.config.OMLG;
          const sortedCards = [...unique].sort((a,b) => allCards.findIndex((item => item === a.productType)) - allCards.findIndex((item => item === b.productType)));
          
          setCardList(sortedCards);          
      }
   },[contentCardList]);
   
  return (
    
<div className="re_afterheader" id="re_afterheader">
   <h2 className="re_select_title">
      You can choose from these {window.global?.config?.[savedChannelCode].length} credit cards
   </h2>
   <div className="re_card_area">
      <div className="re_cards_parent">
      {cardList && cardList?.map((card, i) => {
          return (<div className={ isVerticalCard(card.cardType) ? "re_card_box_ vertical-card":"re_card_box_"} key={i}>
            <div className="re_bgbox" style={{background:`url(${window.location.origin}${card.frontImage})`}}>
               <div className="lefthover"></div>
               <div className="righthover"></div>
               <div className="imagebg"></div>
            </div>
            <p>{card.name}</p>
            <a onClick={() => clickHandler(savedChannelCode)} data-ctype="OLA1" className="re_addtocomparebox_btn_hover" href={ isGemidsNull(gemId1 , gemId2) ?  `${window.location.origin}/sprint/${card.uniqueIdentifier}` : `${window.location.origin}/sprint/${card.uniqueIdentifier}?GEMID1=${gemId1}&GEMID2=${gemId2}` }>Apply Now</a>
               </div>)})
        }
       </div>  
   </div>
</div>
 );
}

export default Cards;
